import dayjs from 'dayjs';
import { useMemo } from 'react';
import { useQuery } from 'react-query';

import { DateTimeFormats, QueryKey } from '@ge/models/constants';
import { Config } from '@ge/shared/data-hooks';
import { useTableFilter } from '@ge/shared/data-hooks/use-table-filter';
import { fetchCRTrackerLockPeriodApi } from '@ge/shared/services/cr_tracker_lock_period';
import { sorter } from '@ge/util/metric-sorter';

export const useCRTrackerLockPeriodTable = ({
  contractId,
  filters,
  search,
  sortMetric,
  sortDirection,
  filterSequence,
}) => {
  const params = {
    contractId,
    currentDate: dayjs().format(DateTimeFormats.YEAR_MONTH_DAY),
  };

  const {
    data: _data,
    error,
    isLoading,
  } = useQuery(
    [QueryKey.CR_TRACKER_LOCK_PERIOD_TABLE, contractId],
    () => fetchCRTrackerLockPeriodApi(params),
    {
      ...Config.EXECUTE_ONCE,
    },
  );

  const { data, filterValues } = useTableFilter({
    data: [...(_data?.data || [])],
    filters,
    search,
    sortMetric,
    sortDirection,
    filterSequence,
  });

  const result = useMemo(() => {
    const tempData = data
      ? sortMetric
        ? data?.sort(sorter(sortMetric, sortDirection))
        : data
      : [];
    return {
      data: tempData,
      filterValues,
      error: error,
      isLoading: isLoading,
    };
  }, [data, sortMetric, sortDirection, filterValues, error, isLoading]);

  return result;
};
